import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  error: null,
  isLoginSucess: false,
  isLoginfailed: null,
};

const loginSlices = createSlice({
  name: "users",
  initialState,
  reducers: {
    setLoginSucess: (state, action) => {
      state.isLoginSucess = action.payload;
    },
    setLoginfailed: (state, action) => {
      state.isLoginfailed = action.payload;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
    logout: (state) => {
      state.isLoginSucess = false;
      state.isLoginfailed = null;
    },
  },
});

export const { setLoginSucess, setLoginfailed, setLoading, setError, logout } = loginSlices.actions;

export default loginSlices.reducer;
